import AddressItem, { AddressItemProps } from './AddressItem';

export type { AddressItemProps };
export default AddressItem;
